import { createSlice } from '@reduxjs/toolkit';

import { fetchBanners } from 'store/slices/banners/actions';
import type { IShopCoupon } from 'types/coupons';
import type { ICustomizableBanner } from './types';

interface IBannersState {
  couponCodeAdvertising: {
    coupon: IShopCoupon;
    endsAt: string;
    amountOfImagesBetweenBanners: number;
  };
  freeShipping: {
    startsFrom: number;
  };
  couponCodeAfterPurchase: {
    coupon: IShopCoupon;
  };
  emptyCartProductSuggestion: {
    enabled: true;
  };
  marketingPhotobooks: {
    enabled: boolean;
    startsAt: number;
    endsAt: number;
    endCustomersStartedStrategy: {
      endCustomerId: string;
      startedAt: number;
      endedAt?: number;
    }[];
  };
  customizableBanners: ICustomizableBanner[];
}

const initialState: Partial<IBannersState> = {};

const bannersSlice = createSlice({
  name: 'banners',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBanners.fulfilled, (_, { payload }) => payload);
  }
});

export const bannersReducer = bannersSlice.reducer;
